import { AxiosError } from 'axios';
import { useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useSearchCustomerInfo = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [fetchedCustomerInfoData, setFetchedCustomerInfoData] = useState<any[]>([]);

    const onSearchCustomerInfoError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(
            err?.response?.data?.message ??
            'Something went wrong while searching for the customer info.',
        );
    };

    const onSearchCustomerInfoSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<SearchCustomerInfoDataResponse>) => {
        setFetchedCustomerInfoData(data?.records || []);
    };

    const searchCustomerInfo = (searchDriver: string) => {
        const urlString = `api/v1/contacts?search=${searchDriver}&page=0&size=20&sort=createdAt%2CDESC`;
        const url: HttpConfig = {
            url: urlString,
            method: 'get',
        };
        request(url, onSearchCustomerInfoSuccess, setLoading, onSearchCustomerInfoError);
    };

    return { searchCustomerInfo, loading, fetchedCustomerInfoData };
};

export default useSearchCustomerInfo;


interface SearchCustomerInfoResponse {
    id: string;
    name: string;
    email: string;
    phoneNumber: string;
    profilePictureUrl: string;

}

interface SearchCustomerInfoDataResponse {
    records: SearchCustomerInfoResponse[];
    totalRecords: number;
    totalPages: number;
}
